import { formatBRL } from "@/utils/money";
import type { TaxClosingTabs } from "@/services/tax-closing";

type TabData = TaxClosingTabs["dinamicaVsLivro"];

interface DynamicsVsBookTabProps {
  data: TabData;
}

export function DynamicsVsBookTab({ data }: DynamicsVsBookTabProps) {
  return (
    <div className="overflow-x-auto border rounded-md">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-muted/50">
            <th className="py-2 px-3 text-left font-medium text-muted-foreground">Rótulos de Linha</th>
            <th className="py-2 px-3 text-right font-medium text-muted-foreground">Soma de NOVA BASE</th>
            <th className="py-2 px-3 text-right font-medium text-muted-foreground">Soma de Base ICMS</th>
            <th className="py-2 px-3 text-right font-medium text-muted-foreground">Soma de Valor ICMS</th>
          </tr>
        </thead>
        <tbody>
          {data.groups.map((group) => (
            <>
              {/* Store header */}
              <tr key={`h-${group.empresa}`} className="bg-muted border-b">
                <td colSpan={4} className="py-2 px-3 font-semibold">
                  Loja {group.empresa}
                </td>
              </tr>

              {/* CFOP detail rows — yellow bg matching the reference spreadsheet */}
              {group.cfopRows.map((row: any, i: number) => (
                <tr key={`${group.empresa}-${i}`} className="border-b bg-yellow-50 hover:bg-yellow-100/60">
                  <td className="py-2 px-3 pl-8">{row.cfop}</td>
                  <td className="py-2 px-3 text-right">{formatBRL(row.sumNovaBaseIcms)}</td>
                  <td className="py-2 px-3 text-right">{formatBRL(row.sumBaseIcms)}</td>
                  <td className="py-2 px-3 text-right">{formatBRL(row.sumValorIcms)}</td>
                </tr>
              ))}

              {/* Subtotal row */}
              <tr key={`s-${group.empresa}`} className="border-b bg-muted/40 font-bold">
                <td className="py-2 px-3 pl-8">Subtotal Loja {group.empresa}</td>
                <td className="py-2 px-3 text-right">{formatBRL(group.subtotal.sumNovaBaseIcms)}</td>
                <td className="py-2 px-3 text-right">{formatBRL(group.subtotal.sumBaseIcms)}</td>
                <td className="py-2 px-3 text-right">{formatBRL(group.subtotal.sumValorIcms)}</td>
              </tr>
            </>
          ))}

          {/* Grand total */}
          <tr className="border-t-2 bg-muted/70 font-bold text-base">
            <td className="py-3 px-3">Total Geral</td>
            <td className="py-3 px-3 text-right">{formatBRL(data.grandTotal.sumNovaBaseIcms)}</td>
            <td className="py-3 px-3 text-right">{formatBRL(data.grandTotal.sumBaseIcms)}</td>
            <td className="py-3 px-3 text-right">{formatBRL(data.grandTotal.sumValorIcms)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
